import React, { useEffect, useMemo } from "react";
// import Header from './../../components/Header';
import { useState } from "react";
import { getBranchByBankName } from "./../../stores/services/branch.service";
import ReactTooltip from "react-tooltip";
import { getFundByAmc } from "./../../stores/services/funds.service";
import { useHistory } from "react-router-dom";
import { IoIosClose } from "react-icons/io";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "reactstrap";
import Select from "react-select";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import ToggleButton from "react-toggle-button";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import InputMask from "react-input-mask";
import {
  numberWithCommas,
  typeRatioSystematic,
} from "../../utils/customFunction";
import { getInvestorByID } from "../../stores/services/potential-investor.service";
import moment from "moment";
import { getSalesCompanyByAMCCode } from "../../stores/services/sales.service";
import { useInvestmentTransaction } from "../../hooks/useVpsTransaction";
import { useCustomStylesDropDown } from "../../assets/css/customStyle";

const ViewClient = () => {
  const history = useHistory();
  //hooks for getting all inputs from user
  const [amcName, setAmcName] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [joiningDate, setJoiningDate] = useState("");
  const [employeeNominee, setEmployeeNominee] = useState<any>([
    {
      nominee_name: "",
      nominee_relation: "",
      nominee_cnic: "",
    },
  ]);
  const [autoInvest, setAutoInvest] = useState("false");
  const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
  const [name, setName] = useState("");
  const [folioNo, setFolioNo] = useState("");
  const [cnic, setCnic] = useState("");
  const [cnicExpiry, setCnicExpiry] = useState("");
  const [ntn, setNtn] = useState("");
  const [mainFolioNo, setMainFolioNo] = useState("");
  const [taxStatus, setTaxStatus] = useState("");
  const [riskFactor, setRiskFactor] = useState("");
  const [DOB, setDOB] = useState("");
  const [calculateAge, setCalculateAge] = useState<any>();
  const [image, setImage] = useState<any>("");
  //
  const [clientEmail, setClientEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [leavingDate, setLeavingDate] = useState("");
  // const [filer, setFiler] = useState(false)	;
  // const updateFiler = () => setFiler(!filer);
  const [province, setProvince] = useState("");
  //
  const [accTitle, setAccTitle] = useState("");
  const [accNo, setAccNo] = useState("");
  const [bankname, setBankName] = useState("");
  const [branchName, setBranchName] = useState("");
  //
  const [blnUpdate, setBlnUpdate] = useState<any>();
  const [reinvestCheck, setReinvestCheck] = useState(false);
  const [lifetimeCNIC, setLifetimeCNIC] = useState(false);

  const email = sessionStorage.getItem("email") || "";
  const [fundLoading, setFundLoading] = useState<boolean>(false);

  const [father, setFather] = useState("");
  const [tax_exempt, setTax_exempt] = useState(false);
  const [zakat_exempt, setZakat_exempt] = useState(false);
  const [type, setType] = useState("");
  const [fund, setFund] = useState("");
  // guardian
  const [guardian_name, setGuardian_name] = useState("");
  const [guardian_relation, setGuardian_relation] = useState("");
  const [guardian_cnic, setGuardian_cnic] = useState("");
  const [joint_h_1_taxStatus, setJointHolderOneTaxStatus] = useState("");
  // nominee
  const [nominee_name, setNomineeNname] = useState("");
  const [nominee_relation, setNomineeRelation] = useState("");
  const [nominee_cnic, setNomineeCnic] = useState("");
  // joint_holder One
  const [joint_h_1_name, setJointHolderOneName] = useState("");
  const [joint_h_1_father_spouse, setJointHolderOneFather] = useState("");
  const [joint_h_1_cnic, setJointHolderOneCnic] = useState("");
  // joint_holder two
  const [joint_h_2_name, setJointHolderTwoName] = useState("");
  const [joint_h_2_father_spouse, setJointHolderTwoFather] = useState("");
  const [joint_h_2_cnic, setJointHolderTwoCnic] = useState("");
  const [joint_h_2_taxStatus, setJointHolderTwoTaxStatus] = useState("");
  // joint_holder Three
  const [joint_h_3_name, setJointHolderThreeName] = useState("");
  const [joint_h_3_father_spouse, setJointHolderThreeFather] = useState("");
  const [joint_h_3_cnic, setJointHolderThreeCnic] = useState("");
  const [joint_h_3_taxStatus, setJointHolderThreeTaxStatus] = useState("");
  const [portfolioManagement, setPortfolioManagement] = useState("");

  const [cdc_IAS, setCDCIAS] = useState("");
  const [cdc_subAccount, setCDCSubAccount] = useState("");
  const [cdc_participantID, setCDCParticipantID] = useState("");
  const amc_code: string = sessionStorage.getItem("amc_code") || "";
  const [salesCompany, setSalesCompany] = useState("");
  const [salesPerson, setSalesPerson] = useState("");
  const [salesInHouse, setSalesInHouse] = useState("");
  const [unitholderType, setUnitholderType] = useState("");
  const [typeVPS, setTypeVPS] = useState("");
  const [amount, setAmount] = useState<any>();
  const [errorThreshold, setErrorThreshold] = useState(false);
  const [totalInvestment, setTotalInvestment] = useState<any>("");
  const [subFundsBlocks, setSubFundsBlocks] = useState<any>([]);
  const [errors, setErrors] = useState<{ [key: number]: string | null }>({});
  const [navDate, setNavDate] = useState(moment().format("YYYY-MM-DD"));

  const { customStyles } = useCustomStylesDropDown();
  const { navLoading, handleUnitholderChange } = useInvestmentTransaction();

  useEffect(() => {
    const obj = JSON.parse(sessionStorage.getItem("clientObj") || "");
    const getAllSalesCompany = async () => {
      try {
        const response = await getSalesCompanyByAMCCode(email, amc_code);
        if (response.data.status == 200) {
          let allSalesCompany = response?.data?.data;
          const selectedFund =
            allSalesCompany &&
            allSalesCompany?.find(
              (item) => item?.company_code === obj?.sales_company,
            );

          const salesPerson =
            allSalesCompany &&
            allSalesCompany
              ?.filter((ele) => ele?.company_code == obj?.sales_company)[0]
              ?.persons?.find((item) => item?.id == obj?.sales_person);
          setSalesCompany(selectedFund?.company_name || "");
          if (selectedFund?.company_name) {
            setSalesPerson(`${salesPerson?.name}(${salesPerson?.email})`);
          } else {
            setSalesPerson("");
          }
        }
      } catch (error) {}
    };
    getAllSalesCompany();
  }, []);

  useEffect(() => {
    const fetchAndUpdate = async () => {
      const obj = JSON.parse(sessionStorage.getItem("clientObj") || "{}");
      obj.unitholder_Type = obj?.unitholder_Type || "Unitholder";
      if (obj && Object.keys(obj).length > 0) {
        // Pass false to preserve existing selected accounts

        if (obj?.unitholder_Type === "Participant") {
          const subFund = await handleUnitholderChange(obj, navDate);
          setSubFundsBlocks(subFund);
        }
      }
    };

    fetchAndUpdate();
  }, [navDate]);

  React.useEffect(() => {
    const obj = JSON.parse(sessionStorage.getItem("clientObj") || "");
    if (obj.balance_unit) {
      setTotalFunds(JSON.parse(obj.balance_unit));
    }
    setAccTitle(obj.account_title);
    setAccNo(obj.account_no);
    setPhone(obj.phone);
    setType(obj.type);
    setFather(obj.father_spouse);
    if (obj.tax_exempt === "true") {
      setTax_exempt(true);
    } else {
      setTax_exempt(false);
    }
    if (obj.zakat_exempt === "true") {
      setZakat_exempt(true);
    } else {
      setZakat_exempt(false);
    }
    setDOB(obj?.dob || "");
    setCalculateAge(obj?.age || "");
    setImage(obj?.profile_picture || "");
    setRiskFactor(obj?.risk_factor || "");
    setCnicExpiry(obj.cnic_expiry);
    setClientEmail(obj.email);
    setMainFolioNo(obj.main_folio_no);
    setBankName(obj.bank_name);
    getBranchByName(obj.bank_name);
    setBranchName(obj.branch_name);
    setAmcName(obj.amc_code);
    setBlnUpdate(obj.balance_unit);
    setLeavingDate(obj?.leaving_date || "");
    setFolioNo(obj.folio_no.replace("UNITHOLDER_", ""));
    setCnic(obj.cnic);
    setName(obj.name);
    setNtn(obj.ntn);
    setAddress(obj.address);
    setMobile(obj.mobile);
    // guardian Name
    setGuardian_name(obj.guardian_name);
    setGuardian_relation(obj.guardian_relation);
    setGuardian_cnic(obj.guardian_cnic);
    setNomineeNname(obj.nominee_name);
    setNomineeRelation(obj.nominee_relation);
    setNomineeCnic(obj.nominee_cnic);
    setJointHolderOneName(obj.joint_h_1_name);
    setJointHolderOneFather(obj.joint_h_1_father_spouse);
    setJointHolderOneCnic(obj.joint_h_1_cnic);
    setJointHolderTwoName(obj.joint_h_2_name);
    setJointHolderTwoFather(obj.joint_h_2_father_spouse);
    setJointHolderTwoCnic(obj.joint_h_2_cnic);
    setJointHolderThreeName(obj.joint_h_3_name);
    setJointHolderThreeFather(obj.joint_h_3_father_spouse);
    setJointHolderThreeCnic(obj.joint_h_3_cnic);
    setPortfolioManagement(obj.portfolio_management);
    setPortfolioManagement(obj.portfolio_management);
    // obj.reinvest === "true" ? setReinvestCheck(true) : setReinvestCheck(false);
    setReinvestCheck(obj.reinvest);
    setLifetimeCNIC(obj?.lifetime_cnic === true ? true : false);
    setCity(obj.city);
    setUnitholderType(obj.unitholder_Type || "Unitholder");
    // setFiler(obj.filer);
    // obj.filer === 'true' ? setFiler(true) : setFiler(false);
    setProvince(obj.province);
    setTaxStatus(obj.tax_status);
    setJointHolderOneTaxStatus(obj.joint_h1_tax_status);
    setJointHolderTwoTaxStatus(obj.joint_h2_tax_status);
    setJointHolderThreeTaxStatus(obj.joint_h3_tax_status);
    setCDCIAS(obj.cdc_ias !== "undefined" ? obj.cdc_ias : "");
    setCDCSubAccount(
      obj.cdc_sub_account !== "undefined" ? obj.cdc_sub_account : "",
    );
    setCDCParticipantID(
      obj.cdc_participant_id !== "undefined" ? obj.cdc_participant_id : "",
    );
    if (obj.systematic_investment) {
      let temp =
        typeof obj.systematic_investment === "object"
          ? obj.systematic_investment
          : JSON.parse(obj.systematic_investment);
      setSubFundsBlocks(temp?.investment_blocks);
      setTotalInvestment(temp?.total_block_invest);
      setTypeVPS(temp?.allocation_scheme);
      setAmount(temp?.investment_amount);
    }
    setSalesInHouse(
      obj.in_house_sale == "true" || obj.in_house_sale == true
        ? "true"
        : "false",
    );
    setSalesCompany(obj.sales_company || "");
    setSalesPerson(obj.sales_person || "");
    if (obj?.unitholder_Type === "Employee") {
      setEmployeeId(obj?.folio_no);
    }
    setJoiningDate(obj.joining_date || "");
    if (obj?.unitholder_Type === "Employee" && obj.employee_nominee) {
      let temp = JSON.parse(obj.employee_nominee);
      setEmployeeNominee(temp);
    }
  }, []);
  const getfundByAmcCode = async (code: string) => {
    allFunds.length = 0;
    setAllFunds(allFunds);
    //get funds by amc for dropdown
    try {
      const response = await getFundByAmc(
        email,
        code,
        fund_code?.length > 0 ? fund_code : "",
      );
      setAllFunds(response.data.data);
      if (response.data.data.length > 0) {
        setFundLoading(false);
      } else {
        setFundLoading(true);
      }
    } catch (error) {}
  };
  //error getting hooks
  const [accTitleError, setAccTitleError] = useState("");
  const [accNoError, setAccNoError] = useState("");
  const [bankNameError, setBankNameError] = useState("");
  const [branchNameError, setBranchNameError] = useState("");
  const [amcNameError, setAmcError] = useState("");
  const [folioNoError, setFolioNoError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [clientEmailError, setClientEmailError] = useState("");
  const [cnicExpiryError, setCnicExpiryError] = useState("");
  const [cnicError, setCnicError] = useState("");
  const [ntnError, setNtnError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [cityError, setCityError] = useState("");
  const [provinceError, setProvinceError] = useState("");
  const [nameError, setNameError] = useState("");
  //for dropdown data
  const [allbranchesData, setAllBranchesData] = useState<any>([]);

  const [allFunds, setAllFunds] = useState<any>([]);
  const [branchLoading, setBranchLoading] = useState<boolean>(false);
  const [totalFunds, setTotalFunds] = useState<any>([]);
  const [branchCheckFlag, setBranchCheckFlag] = useState(false);
  // guardian
  const [allUnitHolders, setAllUnitHolders] = useState<any>([]);

  const getBranchByName = async (name: string) => {
    setBranchLoading(true);
    allbranchesData.length = 0;
    setAllBranchesData(allbranchesData);
    //get all branches for selected bank for dropdown
    try {
      const response = await getBranchByBankName(email, name, amc_code);
      setAllBranchesData(response.data.data);
      if (response.data.data.length > 0) {
        setBranchCheckFlag(false);
      } else {
        setBranchCheckFlag(true);
      }
    } catch (error) {}
    setBranchLoading(false);
  };

  //render Fund table data
  const renderFundDataInTable = () => {
    return totalFunds.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.fund_name ? items.fund_name : items.fund_code}</td>
          <td>
            {items.fund_unit.toString().split(".")[1]
              ? numberWithCommas(items.fund_unit.toString().split(".")[0]) +
                "." +
                String(items.fund_unit.toString().split(".")[1]).slice(0, 4)
              : numberWithCommas(items.fund_unit)}
          </td>
        </tr>
      );
    });
  };
  const borderRadiusStyle = { borderRadius: 2 };

  const renderRange = (ValueIs) => {
    const filteredType = typeRatioSystematic?.find(
      (ele) => ele?.label === typeVPS,
    );
    if (filteredType && ValueIs) {
      return filteredType.ratio[ValueIs] || "";
    }
    return "";
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              {/* <Header /> */}

              <div className="input-holder">
                <h4 className="card-title">View - Unit Holder</h4>
                <Link
                  to={
                    JSON.parse(sessionStorage.getItem("investorObj") || "{}")
                      ?.investor_id
                      ? "/admin/potential-investors"
                      : "/admin/unit-holders"
                  }
                  className="t-3 ml-auto btn btn-primary btn-sm"
                  replace
                >
                  <i className="fa fa-eye mr-2"></i> View All
                </Link>
              </div>

              <Row>
                <Col md="4">
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Registration</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="form-group  ">
                        <label>Type</label>
                        <div className=" ">
                          <input
                            type="text"
                            className={`form-control w-100 `}
                            value={unitholderType}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        {/* <label>Folio No</label> */}
                        <label>Employee No</label>
                        <div className=" ">
                          {unitholderType === "Employee" ? (
                            <input
                              type="text"
                              className={`form-control w-100`}
                              value={employeeId}
                              readOnly
                            />
                          ) : (
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                folioNoError ? "required-border" : ""
                              }`}
                              value={folioNo}
                              readOnly
                            />
                          )}
                        </div>
                      </div>

                      {(unitholderType == "" ||
                        unitholderType !== "Employee") && (
                        <>
                          <Row>
                            <Col md="6">
                              <div className="form-group">
                                <label>Investor Type</label>
                                <div>
                                  <input
                                    readOnly
                                    type="text"
                                    className={"form-control  w-100"}
                                    value={type}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="6">
                              <div className="form-group">
                                <label>Portfolio Management</label>
                                <div>
                                  <input
                                    readOnly
                                    type="text"
                                    className={"form-control  w-100"}
                                    value={
                                      portfolioManagement == "sma"
                                        ? "SMA"
                                        : portfolioManagement
                                    }
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <div className="form-group">
                            <label>Tax Status</label>
                            <div className="form-control">{taxStatus}</div>
                          </div>

                          <div className="d-flex justify-content-between mt-4">
                            {/* <div className="form-group d-flex">  
                          <ToggleButton        
                            value={tax_exempt}
                            thumbStyle={borderRadiusStyle}
                            trackStyle={borderRadiusStyle}
                            onToggle={() => {
                              if (tax_exempt) {
                                setTax_exempt(false);
                              } else {
                                setTax_exempt(true);
                              }
                            }}
                          />
                          <label className="mt-2 ml-2">Tax Exempt</label> 
                    </div> */}

                            <div className="form-group d-flex">
                              <ToggleButton
                                value={zakat_exempt}
                                thumbStyle={borderRadiusStyle}
                                trackStyle={borderRadiusStyle}
                                // onToggle={() => {
                                //   if (zakat_exempt) {
                                //     setZakat_exempt(false);
                                //   } else {
                                //     setZakat_exempt(true);
                                //   }
                                // }}
                                disabled
                              />
                              <label className="mt-2 ml-2">Zakat Exempt</label>
                            </div>

                            <div className="form-group ">
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    checked={reinvestCheck}
                                  />
                                  <span className="form-check-sign" />
                                  Fund Dividend Reinvest
                                </Label>
                              </FormGroup>
                            </div>
                          </div>
                        </>
                      )}

                      {JSON.parse(sessionStorage.getItem("clientObj") || "{}")
                        ?.investor_id && (
                        <button
                          className="t-3 ml-auto btn btn-primary btn-sm"
                          onClick={async () => {
                            try {
                              const response = await getInvestorByID(
                                email,
                                amcName,
                                JSON.parse(
                                  sessionStorage.getItem("clientObj") || "{}",
                                )?.investor_id,
                              );
                              if (response.data.status == 200) {
                                sessionStorage.setItem(
                                  "investorObj",
                                  JSON.stringify(response.data.data),
                                );
                                history.replace(
                                  "/admin/view-potential-investor",
                                );
                              } else {
                                toast.error(response.data.message);
                              }
                            } catch (error: any) {
                              toast.error(
                                error.response.data.message?.toString() ||
                                  error?.message ||
                                  "Request Failed",
                              );
                            }
                          }}
                        >
                          <i className="fa fa-eye mr-2"></i> View Potential
                          Investor
                        </button>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                <Col md="4">
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Personal Details</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="d-flex justify-content-center">
                        {image ? (
                          <div
                            style={{
                              width: "100px",
                              height: "100px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100px",
                                height: "100px",
                              }}
                              className="User_image"
                              src={image}
                            />
                          </div>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="100"
                            height="100"
                            viewBox="0 0 50 50"
                          >
                            <path
                              fill="#949494"
                              d="M25 2.008c-12.69 0-23 10.31-23 23s10.31 23 23 23 23-10.31 23-23-10.31-23-23-23m0 2c11.61 0 21 9.39 21 21a20.92 20.92 0 0 1-6.012 14.705c-1.83-1.343-4.06-2.017-5.949-2.69-1.064-.378-2.02-.753-2.719-1.171-.668-.4-1.04-.813-1.236-1.286-.092-1.146-.073-2.07-.066-3.16.12-.12.276-.205.4-.351.292-.345.59-.764.873-1.235.487-.807.84-1.795 1.04-2.797.302-.154.626-.187.872-.502.455-.58.762-1.396.899-2.533.12-1.004-.203-1.694-.62-2.224.449-1.465 1.003-3.795.815-6.205-.104-1.327-.438-2.662-1.24-3.772-.767-1.06-2.011-1.822-3.604-2.098C28.442 8.541 26.835 8 24.914 8h-.018c-4.302.079-7.078 1.86-8.267 4.576-1.13 2.583-.887 5.799-.076 9.147-.436.53-.778 1.233-.655 2.265.137 1.137.444 1.954.899 2.533.246.315.57.348.873.502.198 1.001.552 1.988 1.039 2.795.284.471.58.89.873 1.235.124.146.28.233.4.353.007 1.09.025 2.013-.066 3.16-.196.472-.567.884-1.234 1.286-.698.42-1.653.797-2.715 1.177-1.887.677-4.116 1.355-5.951 2.688A20.92 20.92 0 0 1 4 25.007c0-11.609 9.39-21 21-21m-.078 5.994c1.844.002 3.004.548 3.322 1.105l.244.428.487.067c1.256.174 1.958.662 2.46 1.357.503.695.783 1.666.868 2.756.17 2.18-.454 4.754-.85 5.945l-.252.756.682.414c-.07-.042.32.189.232.92-.106.89-.334 1.343-.486 1.537s-.218.17-.201.168l-.824.068-.088.823c-.076.706-.473 1.67-.938 2.441a8 8 0 0 1-.687.975c-.208.245-.43.397-.346.353l-.535.28V31c0 1.324-.054 2.407.086 3.95l.011.132.047.125c.394 1.06 1.215 1.806 2.139 2.36s1.983.952 3.076 1.341c1.801.641 3.678 1.272 5.11 2.203A20.9 20.9 0 0 1 25 46.008c-5.134 0-9.829-1.84-13.475-4.893 1.44-.926 3.32-1.559 5.118-2.203 1.092-.391 2.149-.793 3.07-1.348.921-.554 1.74-1.301 2.133-2.357l.047-.125.011-.133c.139-1.54.086-2.624.086-3.949v-.605l-.535-.282c.084.044-.138-.108-.346-.353a8 8 0 0 1-.687-.973c-.465-.771-.862-1.736-.938-2.441l-.088-.823-.824-.068c.016.001-.049.026-.2-.168-.153-.194-.38-.647-.487-1.537-.088-.732.307-.965.232-.92l.635-.385-.186-.72c-.86-3.312-.99-6.325-.105-8.348.884-2.02 2.655-3.303 6.46-3.375"
                            ></path>
                          </svg>
                        )}
                      </div>
                      <div className="form-group  ">
                        <label>Client Name</label>
                        <div className=" ">
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              nameError ? "required-border" : ""
                            }`}
                            value={name}
                          />
                        </div>
                      </div>
                      {(type == "Individual" ||
                        type == "Individuals" ||
                        unitholderType === "Employee") && (
                        <>
                          <div className="form-group  ">
                            <label>DOB</label>
                            <div className=" ">
                              <input
                                type="date"
                                className={`form-control  w-100 `}
                                value={moment(DOB).format("YYYY-MM-DD")}
                                disabled
                              />
                            </div>
                          </div>

                          {unitholderType !== "Employee" && (
                            <>
                              <div className="form-group">
                                <label>Age </label>
                                <div>
                                  <input
                                    disabled
                                    type="text"
                                    value={calculateAge}
                                    className="form-control "
                                  />
                                </div>
                              </div>
                              <div className="form-group  ">
                                <label>Risk Factor</label>
                                <div className=" ">
                                  <input
                                    type="text"
                                    className={`form-control  w-100 `}
                                    value={riskFactor}
                                    disabled
                                  />
                                </div>
                              </div>
                              <div className="form-group">
                                <label>Father/Spouse Name</label>
                                <div>
                                  <input
                                    readOnly
                                    type="text"
                                    className={"form-control  w-100"}
                                    value={father}
                                    onChange={(e) => {
                                      setFather(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                          {unitholderType === "Employee" && (
                            <>
                              <div className="form-group">
                                <label>Joining Date</label>
                                <div>
                                  <input
                                    type="date"
                                    value={joiningDate}
                                    className={`form-control`}
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div className="form-group">
                                <label>Leaving Date</label>
                                <div>
                                  <input
                                    type="date"
                                    value={leavingDate}
                                    className={`form-control`}
                                    readOnly
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}

                      {(type == "Individual" ||
                        type == "Individuals" ||
                        unitholderType === "Employee") && (
                        <Row>
                          <Col md="12" xl="6">
                            <div className="form-group  ">
                              <div className="d-flex justify-content-between align-items-end">
                                <label>CNIC</label>
                                <FormGroup className="mb-1" check>
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      checked={lifetimeCNIC}
                                      readOnly
                                      disabled
                                    />
                                    <span className="form-check-sign" />
                                    Lifetime CNIC
                                  </Label>
                                </FormGroup>
                              </div>
                              <div className=" ">
                                {/* <input
                              type="text"
                              className={`form-control  w-100 ${
                                cnicError ? 'required-border' : ''
                              }`}
                              value={cnic}
                            /> */}
                                <InputMask
                                  className={`form-control  w-100 ${
                                    cnicError ? "required-border" : ""
                                  }`}
                                  mask="99999-9999999-9"
                                  value={cnic}
                                ></InputMask>
                              </div>
                            </div>
                          </Col>
                          <Col md="12" xl="6">
                            <div className="form-group  ">
                              <label>CNIC Expiry</label>
                              <div className=" ">
                                <input
                                  type="date"
                                  className={`form-control  w-100 ${
                                    cnicExpiryError ? "required-border" : ""
                                  }`}
                                  value={moment(cnicExpiry).format(
                                    "YYYY-MM-DD",
                                  )}
                                  disabled
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )}
                      {type === "Corporate" && (
                        <div className="form-group  ">
                          <label>NTN</label>
                          <div className=" ">
                            <input
                              type="number"
                              className={`form-control  w-100 ${
                                ntnError ? "required-border" : ""
                              }`}
                              value={ntn}
                            />
                          </div>
                        </div>
                      )}

                      {/* <FormGroup check>
                            	<Label check>
                          <input		
                            type="checkbox"		
                            // className={`form-control  w-100 ${		
                            //   ntnError ? 'required-border' : ''		
                            // }`}		
                            checked={filer}	
                            readOnly		
                          />
                          <span className="form-check-sign" />
                          Income Tax Return Filer
                          </Label>
                          </FormGroup>		 */}
                    </CardBody>
                  </Card>
                </Col>

                <Col md="4">
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Contact</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="form-group  ">
                        <label>Email</label>
                        <div className="">
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              clientEmailError ? "required-border" : ""
                            }`}
                            value={clientEmail}
                          />
                        </div>
                      </div>

                      <Row>
                        <Col md="6">
                          <div className="form-group  ">
                            <label>Mobile</label>
                            <div className=" ">
                              {/* <input
                            type="number"
                            className={`form-control  w-100 ${
                              mobileError ? 'required-border' : ''
                            }`}
                            value={mobile}
                          /> */}

                              <PhoneInput
                                specialLabel=""
                                inputClass={`form-control  w-100 ${
                                  mobileError ? "required-border" : ""
                                }`}
                                country={"pk"}
                                placeholder="+92 123-1234567"
                                value={mobile}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="form-group  ">
                            <label>Phone</label>
                            <div className=" ">
                              {/* <input
                        type="number"
                        className={`form-control  w-100 ${
                          phoneError ? 'required-border' : ''
                        }`}
                        value={phone}
                      /> */}

                              <PhoneInput
                                specialLabel=""
                                inputClass={`form-control  w-100 ${
                                  phoneError ? "required-border" : ""
                                }`}
                                country={"pk"}
                                placeholder="+92 123-1234567"
                                value={phone}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <div className="form-group  ">
                        <label>Address</label>
                        <div className=" ">
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              addressError ? "required-border" : ""
                            }`}
                            value={address}
                          />
                        </div>
                      </div>

                      <Row>
                        <Col>
                          <div className="form-group  ">
                            <label>City</label>
                            <div className=" ">
                              <select className="form-control" value={city}>
                                <option value={city} defaultChecked hidden>
                                  {city}
                                </option>
                              </select>
                            </div>
                          </div>
                        </Col>

                        <Col>
                          <div className="form-group  ">
                            <label>Territories</label>
                            <div className=" ">
                              <select className="form-control" value={province}>
                                <option value={province} defaultChecked hidden>
                                  {province}
                                </option>
                              </select>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col md="4">
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Bank Account Detail</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="form-group  ">
                        <label>Account Title</label>
                        <div className=" ">
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              accTitleError ? "required-border" : ""
                            }`}
                            value={accTitle}
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Account No</label>
                        <div className="  ">
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              accNoError ? "required-border" : ""
                            }`}
                            value={accNo}
                          />
                        </div>
                      </div>

                      <Row>
                        <Col md="6">
                          <div className="form-group  ">
                            <label>Bank Name</label>
                            <div className="  ">
                              <select className="form-control" value={bankname}>
                                <option value={bankname} defaultChecked hidden>
                                  {bankname}
                                </option>
                              </select>
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="form-group  ">
                            <label>Branch Name</label>

                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                bankNameError ? "required-border" : ""
                              }`}
                              value={branchName}
                              onChange={(e) => {
                                setBankNameError("");
                                setBranchName(e.target.value);
                              }}
                            />

                            {/* <div className="" id="x">
                          {branchLoading ? (
                            <div className="form-control">
                              <div className="ml-2">Branch Loading</div>
                              <img
                                src="assets/spin-loader.svg"
                                className="ml-auto pb-2 center"
                                alt=""
                                width={40}
                                height={70}
                              />
                            </div>
                          ) : (
                            <select
                              className={`form-control  w-100 ${
                                branchNameError ? 'required-border' : ''
                              }`}
                              value={branchName}
                            >
                              <option value="" defaultChecked hidden>
                                {branchCheckFlag
                                  ? 'No Branch Found'
                                  : 'Select Branch Name'}
                              </option>
                              {renderBranchsDropdown()}
                            </select>
                          )}
                        </div> */}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                {/*add new cards  */}
                {type === "Individual" && (
                  <Col md="4">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Guardian Details</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <div className="form-group">
                          <label>Guardian Name </label>
                          <div>
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              value={guardian_name}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Guardian Relation </label>
                          <div>
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              value={guardian_relation}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Guardian CNIC </label>
                          <div>
                            {/* <input		
                        type="text"		
                        className={`form-control  w-100 ${		
                          nameError ? 'required-border' : ''		
                        }`}		
                        value={allUnitHolders.guardian_cnic}		
                       	
                      />	 */}
                            <InputMask
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              mask="99999-9999999-9"
                              value={guardian_cnic}
                            ></InputMask>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                )}

                {type === "Individual" && (
                  <Col md="4">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Nominee Details</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <div className="form-group">
                          <label>Nominee Name </label>
                          <div>
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              value={nominee_name}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Nominee Relation </label>
                          <div>
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              value={nominee_relation}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Nominee CNIC </label>
                          <div>
                            {/* <input		
                        type="text"		
                        className={`form-control  w-100 ${		
                          nameError ? 'required-border' : ''		
                        }`}		
                        value={allUnitHolders.nominee_cnic}		 
                      />		 */}
                            <InputMask
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              mask="99999-9999999-9"
                              value={nominee_cnic}
                            ></InputMask>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                )}
                {unitholderType && unitholderType !== "Employee" && (
                  <>
                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Joint Holder 1</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <div className="form-group">
                            <label> Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_1_name}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> Father/Spouse Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_1_father_spouse}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> CNIC </label>
                            <div>
                              {/* <input		
                        type="text"		
                        className={`form-control  w-100 ${		
                          nameError ? 'required-border' : ''		
                        }`}		
                        value={allUnitHolders.joint_h_1_cnic}	 	
                      />		 */}
                              <InputMask
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                mask="99999-9999999-9"
                                value={joint_h_1_cnic}
                              ></InputMask>
                            </div>
                          </div>

                          <div className="form-group">
                            <label>Tax Status</label>
                            <div className="form-control">
                              {joint_h_1_taxStatus}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Joint Holder 2</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <div className="form-group">
                            <label> Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_2_name}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> Father/Spouse Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_2_father_spouse}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> CNIC </label>
                            <div>
                              {/* <input		
                        type="text"		
                        className={`form-control  w-100 ${		
                          nameError ? 'required-border' : ''		
                        }`}		
                        value={allUnitHolders.joint_h_2_cnic}		 
                      />		 	 */}
                              <InputMask
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                mask="99999-9999999-9"
                                value={joint_h_2_cnic}
                              ></InputMask>
                            </div>
                          </div>

                          <div className="form-group">
                            <label>Tax Status</label>
                            <div className="form-control">
                              {joint_h_2_taxStatus}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Joint Holder 3</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <div className="form-group">
                            <label> Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_3_name}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> Father/Spouse Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_3_father_spouse}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> CNIC </label>
                            <div>
                              {/* <input		
                        type="text"		
                        className={`form-control  w-100 ${		
                          nameError ? 'required-border' : ''		
                        }`}		
                        value={allUnitHolders.joint_h_3_cnic}		 
                      />		 */}
                              <InputMask
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                mask="99999-9999999-9"
                                value={joint_h_3_cnic}
                              ></InputMask>
                            </div>
                          </div>

                          <div className="form-group">
                            <label>Tax Status</label>
                            <div className="form-control">
                              {joint_h_3_taxStatus}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">CDC</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <div className="form-group">
                            <label>Investment Account Service</label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 `}
                                value={cdc_IAS}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> CDC Subaccount </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 `}
                                value={cdc_subAccount}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>CDC participant ID</label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 `}
                                value={cdc_participantID}
                              />
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Balance Units</CardTitle>
                        </CardHeader>
                        <CardBody>
                          {totalFunds.length > 0 && (
                            // <div className="input-size-pos w-50 ml-auto mb-3 mx-3">
                            <div className="">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Fund Name</th>
                                    <th>Fund Unit</th>
                                  </tr>
                                </thead>
                                <tbody>{renderFundDataInTable()}</tbody>
                              </table>
                            </div>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Sales Details</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <div className="form-group">
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  checked={
                                    salesInHouse == "true" ? true : false
                                  }
                                />
                                <span className="form-check-sign" />
                                In house sale
                              </Label>
                            </FormGroup>
                          </div>

                          <div className="form-group">
                            <label>Sales Company</label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 `}
                                value={salesCompany}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Sales Person</label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 `}
                                value={salesPerson}
                              />
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </>
                )}

                {unitholderType === "Participant" ? (
                  <Col md="12">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Systematic investment</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <Row>
                          <Col>
                            <div className="form-group">
                              <label>Allocation Scheme</label>
                              <div>
                                <div>
                                  <input
                                    type="text"
                                    className={`form-control  w-100 `}
                                    value={typeVPS}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>

                          {/* <Col>
                            <div className="form-group">
                              <label>Withdrawal Amount</label>
                              <div>
                                <input
                                  type="text"
                                  className={`form-control  w-100 `}
                                  value={amount}
                                />
                              </div>
                            </div>
                          </Col> */}

                          <Col>
                            <div className="form-group">
                              <label>Nav Date</label>
                              <div>
                                <input
                                  type="date"
                                  className={`form-control w-100`}
                                  value={navDate}
                                  onChange={(e) => {
                                    setNavDate(e?.target?.value);
                                  }}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        {amount > 0 &&
                          subFundsBlocks?.map((block, blockIndex) => {
                            return (
                              <div
                                key={block?.id}
                                style={{
                                  marginBottom: "15px",
                                }}
                              >
                                <Row>
                                  <Col>
                                    <div className="form-group">
                                      <label>Fund</label>
                                      <div>
                                        <Select
                                          isDisabled={true}
                                          value={block?.selectedParentFund}
                                          style={customStyles}
                                        />
                                      </div>
                                    </div>
                                  </Col>

                                  <Col>
                                    <div className="form-group">
                                      <label>Current Investment</label>
                                      <div style={{ position: "relative" }}>
                                        <h1 className={`form-control w-100`}>
                                          {numberWithCommas(
                                            parseFloat(
                                              block?.total_holding || 0,
                                            ).toFixed(2),
                                          )}
                                        </h1>
                                      </div>
                                    </div>
                                  </Col>

                                  <Col>
                                    <div className="form-group">
                                      <label>Amount</label>
                                      <div style={{ position: "relative" }}>
                                        <input
                                          type="text"
                                          className={`form-control w-100`}
                                          value={numberWithCommas(
                                            parseFloat(
                                              block?.total_amount || 0,
                                            ).toFixed(2),
                                          )}
                                        ></input>
                                        {/* <NumberFormat
                                          value={block?.total_amount}
                                          className={`form-control pr-5`}
                                          disabled
                                          decimalScale={2}
                                          allowNegative={false}
                                        /> */}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>

                                {!navLoading &&
                                  (block?.fund ||
                                    block?.fund_code ||
                                    block?.fund_name) && (
                                    <>
                                      {/* Header Row for SubFunds */}
                                      <Row className="mt-3">
                                        <Col>
                                          <strong>Fund Name</strong>
                                        </Col>

                                        <Col>
                                          <strong>Current Holding</strong>
                                        </Col>

                                        <Col>
                                          <strong>Allocation %</strong>
                                        </Col>

                                        <Col>
                                          <strong>Amount</strong>
                                        </Col>
                                      </Row>

                                      {block?.subFunds?.map(
                                        (ele: any, fundIndex) => {
                                          return (
                                            <Row
                                              style={{
                                                alignItems: "end",
                                              }}
                                              key={fundIndex}
                                              className="mt-2"
                                            >
                                              {/* Fund Name */}
                                              <Col>
                                                <div className="form-group">
                                                  <input
                                                    value={ele?.name}
                                                    readOnly
                                                    className="form-control"
                                                  />
                                                </div>
                                              </Col>

                                              {/* Current Holding */}
                                              <Col>
                                                <div className="d-flex pt-2 pb-2 text-md ">
                                                  <h5 className="mr-4">
                                                    Units:{" "}
                                                    <span className="font-weight-bold">
                                                      {numberWithCommas(
                                                        parseFloat(
                                                          ele?.holding,
                                                        ).toFixed(4) || "0",
                                                      )}
                                                    </span>
                                                  </h5>
                                                  <h5 className="">
                                                    Amount:{" "}
                                                    <span className="font-weight-bold">
                                                      {numberWithCommas(
                                                        parseFloat(
                                                          (
                                                            parseFloat(
                                                              ele?.holding,
                                                            ) *
                                                            parseFloat(ele?.nav)
                                                          ).toFixed(2),
                                                        ) || "0",
                                                      )}
                                                    </span>
                                                  </h5>
                                                </div>
                                              </Col>

                                              {/* Proportion */}
                                              <Col>
                                                <div className="form-group">
                                                  <div
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    {typeVPS ===
                                                    "Customized Allocation Scheme" ? (
                                                      <>
                                                        <FormGroup check>
                                                          <Label
                                                            style={{
                                                              bottom: "12px",
                                                            }}
                                                            check
                                                          >
                                                            <Input
                                                              type="checkbox"
                                                              disabled
                                                              checked={
                                                                parseFloat(
                                                                  ele?.proportion,
                                                                ) === 100
                                                              }
                                                            />
                                                            <span className="form-check-sign" />
                                                          </Label>
                                                        </FormGroup>
                                                        <input
                                                          type="text"
                                                          className={`form-control w-100`}
                                                          value={numberWithCommas(
                                                            parseFloat(
                                                              ele?.proportion ||
                                                                0,
                                                            ).toFixed(2),
                                                          )}
                                                        />
                                                        {/* <NumberFormat
                                                      value={ele?.proportion}
                                                      className={`form-control pr-5`}
                                                      disabled
                                                      decimalScale={2}
                                                      allowNegative={false}
                                                    /> */}
                                                      </>
                                                    ) : (
                                                      <>
                                                        <input
                                                          type="text"
                                                          className={`form-control w-100`}
                                                          value={numberWithCommas(
                                                            parseFloat(
                                                              ele?.proportion ||
                                                                0,
                                                            ).toFixed(2),
                                                          )}
                                                        />
                                                        {/* <NumberFormat
                                                    value={ele?.proportion}
                                                    className={`form-control pr-5`}
                                                    disabled
                                                  /> */}
                                                      </>
                                                    )}
                                                    <span
                                                      className={`input-group-text`}
                                                      style={{
                                                        position: "absolute",
                                                        right: "10px",
                                                        top:
                                                          typeVPS ===
                                                          "Customized Allocation Scheme"
                                                            ? "66%"
                                                            : "51%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        background:
                                                          "transparent",
                                                        border: "none",
                                                        pointerEvents: "none",
                                                      }}
                                                    >
                                                      %
                                                    </span>
                                                  </div>
                                                </div>
                                              </Col>

                                              {/* Amount */}
                                              <Col>
                                                <div className="form-group">
                                                  <input
                                                    type="text"
                                                    className={`form-control w-100`}
                                                    value={numberWithCommas(
                                                      parseFloat(
                                                        ele?.amount || 0,
                                                      ).toFixed(2),
                                                    )}
                                                  />
                                                </div>
                                              </Col>
                                            </Row>
                                          );
                                        },
                                      )}
                                    </>
                                  )}

                                {navLoading && (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      padding: "20px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-spinner fa-spin"
                                      style={{
                                        fontSize: "24px",
                                        color: "#007bff",
                                      }}
                                    ></i>
                                    <div>Loading NAV data...</div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </CardBody>
                    </Card>
                  </Col>
                ) : null}

                {unitholderType && unitholderType === "Employee" && (
                  <Col md="12">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Nominee</CardTitle>
                      </CardHeader>
                      <CardBody>
                        {employeeNominee?.map((ele, index) => {
                          return (
                            <Row>
                              <Col>
                                <div className="form-group">
                                  <label>Nominee Name</label>
                                  <div>
                                    <input
                                      type="text"
                                      className={`form-control w-100 `}
                                      value={ele?.nominee_name}
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col>
                                <div className="form-group">
                                  <label>Nominee Relation</label>
                                  <div>
                                    <input
                                      type="text"
                                      className={`form-control w-100 `}
                                      value={ele?.nominee_relation}
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col>
                                <div className="form-group">
                                  <label>Nominee CNIC</label>
                                  <div>
                                    <input
                                      type="text"
                                      className={`form-control w-100 `}
                                      value={ele?.nominee_cnic}
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          );
                        })}
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ViewClient;
